import React, { useContext } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { AudioContext } from '../contexts/AudioContext';
import { getRecentListeningRanges } from '../db';

function RecentListens({ closeMenu }) {
  const { setCurrentChapter, updateSession, setIsPlaying } = useContext(AudioContext);
  
  // Use live query to observe database changes automatically
  const ranges = useLiveQuery(() => getRecentListeningRanges(), []) || [];

  const handleResume = (range) => {
    const { formattedResume } = range;
    
    // Resume playback
    setCurrentChapter(formattedResume);
    setIsPlaying(true);
    
    // Update the session tracker (starts logging this as a new/current session)
    updateSession(formattedResume);
    
    closeMenu(true);
  };

  return (
    <div className="recent-listens">
      <h2>Recent Listens</h2>
      <ul>
        {ranges.map((range, index) => (
          <li key={`${range.label}-${index}`}>
            <button onClick={() => handleResume(range)}>
              {range.label}
              {/* Optional: Add timestamp if needed by design, but not strictly requested */}
            </button>
          </li>
        ))}
        {ranges.length === 0 && (
            <li className="empty-state" style={{ padding: '10px', color: '#888' }}>
                No recent listening history found.
            </li>
        )}
      </ul>
    </div>
  );
}

export default RecentListens;
